import { Col, Card } from "react-bootstrap";
import { RouterPath } from "../../../assets/dictionary/RouterPath";
import { useNavigate } from "react-router-dom";

export default function ForgotPasswordEmailSent(props) {
  const Navigate = useNavigate();
  return (
    <>
      {/* <Container> */}
      <div className="d-flex justify-content-center align-items-center flex-column vh-100">

        {/* <Row className="justify-content-center pt-5 content-wrapper "> */}
          <Col xs={12} sm={10} md={8} lg={6} xl={4} >
            <div className="glass-card">
              {/* <Card style={{ borderRadius: "15px" }}> */}
              <Card.Body>
                <Card.Title className="mb-3">L'email a été envoyé !</Card.Title>
                <Card.Text>Vérifiez votre email pour réinitialiser le mot de passe.</Card.Text>
                <Card.Text className="text-disabled"><small>Pensez à vérifier vos spams.</small></Card.Text>
                <button
                  type="button"
                  className="btn-primary mb-3 w-100"
                  onClick={() => Navigate(RouterPath.LOGIN)}
                  
                >
                  Retour à la page de connexion
                </button>
                {/* <Link to={RouterPath.HOME}>
                  <Button variant="primary" type="submit" className="w-100">
                    Retour à la page d'accueil
                  </Button>
                </Link> */}
              </Card.Body>
              {/* </Card> */}
            </div>
          </Col>
        {/* </Row> */}
      </div>
      {/* </Container> */}
    </>
  );
}
